module.exports = __webpack_public_path__ + "static/img/ing.6f65d7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ing.png
// module id = U5BV
// module chunks = 12